export const PIECE_CELL_SIZE = 32; // px
export const PIECE_CELL_THUMB_SIZE = 16; // px

export const NUM_ROWS = 15;
export const NUM_COLUMNS = 10;

export const GameStatuses = {
  stopped: 'stopped',
  started: 'started',
  over: 'over',
  paused: 'paused',
};

export const COLORS = [
  "yellow", "green", "blue",
  "orange", "silver", "red",
  // "purple",
];

export const ACCELERATION_FACTOR = 0.9;

